<template>
    <section class="chart-container">
        <!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
                <el-form-item label="项目">
					<el-select v-model="filters.projectId" multiple  collapse-tags   @change="getDevices" style="width:250px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称" >
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn" style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn"  multiple collapse-tags  @change="getFactorsByMn" style="width:320px" filterable reserve-keyword>
                        <el-option value="-1" label="全选"></el-option>
                        <el-option value="-2" label="取消全选"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                  <el-form-item label="因子">
					<el-select v-model="filters.facKeyword"  @change="getFactorName" style="max-width:150px" filterable>
						<el-option
							v-for="item in facList"
							:label="item.name"
							:value="item.keyword" :key="item.keyword">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="数据类型" >
					<el-select v-model="dataType" placeholder="请选择数据类型"  style="max-width:100px"  @change="getDataType" >
						<el-option label="分钟" value="min"></el-option>
						<el-option label="小时" value="hour"></el-option>
						<el-option label="天" value="day"></el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="时间">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="dataType=='min'?pickerOptionsMin:pickerOptionsHour" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期" style="max-width:340px" align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
				</el-form-item>

                <el-form-item label="显示联动">
                    <el-switch v-model="linkage" @change="changeLinkage"></el-switch>
                </el-form-item>
			</el-form>
		</el-col>

        <el-tag :key="tag" v-for="tag in dynamicTags"   :disable-transitions="false"   class="dataTab" @click="TabClick">  {{tag}} </el-tag>

        <!-- 折线图 -->
        <el-col :span="24"   v-loading="listLoading">
            <div id="chartLine" ></div>
        </el-col>

        <el-dialog  title="详情" :visible.sync="deviceDataVisible" :close-on-click-modal="true" >
            <el-tag    effect="plain">    点位名称：{{ chooseDeviceName }} </el-tag>
            <el-tag    effect="plain" style="margin-left: 20px;">    时间：{{ chooseTime }} </el-tag>
            <el-tag    effect="plain" style="margin-left: 20px;">    数值：{{ chooseValue }} </el-tag>

            <el-descriptions title="异常报警"  :column="3" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="stateInfo.length>0">
                <template v-for="item in stateInfo">
                    <el-descriptions-item  label="点位名称"> {{chooseDeviceName}}  </el-descriptions-item>
                    <el-descriptions-item  label="时间"> {{item.time}}  </el-descriptions-item>
                    <el-descriptions-item  label="事件"> {{item.remark}} </el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="声源定位"  :column="3" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="noiseVideo.length>0">
                <template v-for="item in noiseVideo">
                    <el-descriptions-item  label="点位名称"> {{chooseDeviceName}}  </el-descriptions-item>
                    <el-descriptions-item  label="时间"> {{item.alarmDate}}  </el-descriptions-item>
                    <el-descriptions-item  label="操作"> 
					    <el-button size="small" @click="showIdent(item)">查看视频</el-button>
                    </el-descriptions-item>
                </template>
            </el-descriptions>
            <el-descriptions title="噪声录音"  :column="3" border style="margin-top: 30px;max-height: 25vh;overflow-y: auto;" v-if="recording.length>0">
                <template v-for="item in recording">
                    <el-descriptions-item  label="点位名称"> {{chooseDeviceName}}  </el-descriptions-item>
                    <el-descriptions-item  label="时间"> {{item.startTime}}  </el-descriptions-item>
                    <el-descriptions-item  label="操作"> 
                        <audio :src="item.src" controls="controls"></audio>
                    </el-descriptions-item>
                </template>
            </el-descriptions>
        </el-dialog>

        <el-dialog title="视频详情" :visible.sync="soundVisible" top="8vh" >
			<video :src="mp4Src" controls="controls" style="width: 100%;"></video>
		</el-dialog>
        
    </section>
</template>

<script>
    import * as echarts from "echarts";
    import {getProjects,getDevicesByProjectId,getFactorsByMn,selectNoiseDataForTime,exportToExcel} from '../../api/api';
    import {formatDate,in_array,getIcons,getResourceUrl,setDeviceEvent,factorExcept,minFactorExcept,hourFactorExcept} from '../../../static/fun.js';

    import myButton from '../../components/myButton/index.vue'

    export default {
        props: {
            collapsed: {
                type: Boolean,
            },
        },
        components: { myButton },
        data() {
            return {
               	pickerOptionsMin: {
                    shortcuts: [{
                        text: '最近一小时',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近六小时',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 6);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近半天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 12);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一天',
                         onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                pickerOptionsHour: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                filters: {
                    mn: '',
                    facKeyword:'',
                    projectId:'',
                    time:[]
                },
                chartLine: null,
                projects:[],
                devices:[],
                factors:[],
                facList:[],
                factorName:'',
                chooseNames:[],
                data:[],
                listLoading:false,
                firstFlag:true,
                formHeight:0,
                dataType:'min',

                type:1,
                fatherUserId:1,
                dynamicTags: ["分钟"],
				filtersChche:{
					hour:{},
					min:{},
					day:{}
				},
                dataObjMap:new Map(),
                deviceMap:new Map(),
				linkage:false,
                noiseVideo:[],
                recording:[],
                stateInfo:[],
                deviceDataVisible:false,
                mp4Src:"",
                soundVisible:false,
                chooseDeviceName:"",
                dayLimit:31,
                chooseTime:"",
                chooseValue:''
            }
        },
        watch: {
            'collapsed': {
                handler (val) {
                    if(this.chartLine!=null){
                        this.chartLine.resize();
                    }
                },
                deep: true
            },
        },
        methods: {
            clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="export"){
					this.dataTableToExcel();
				}
			},
            changeLinkage(){
                this.getDataList();
            },
            showIdent(row){
                this.mp4Src=getResourceUrl()+"noisevideo/"+row.videoPaths;
                this.soundVisible=true;
            },
            TabClick(e){
				var obj={};
				var tab=e.target.innerText;
				if(tab=="分钟"){
					obj=this.filtersChche.min;
				}else if(tab=="小时"){
					obj=this.filtersChche.hour;
				}else{
					obj=this.filtersChche.day;
				}
				var aData =obj.aData;
                var seriesData =obj.seriesData;
				this.factorName=obj.factorName;
				this.filters=obj.filters;
                this.dataObjMap=obj.dataObjMap;
                this.dataType=obj.dataType;
                this.changeTabClass(tab);

                this.drawLineChart(aData,seriesData); 
			},
			addTab(aData,seriesData) {
				var obj={
					aData:aData,
					seriesData:seriesData,
					factorName:this.factorName,
					filters:JSON.parse(JSON.stringify(this.filters)),
					dataObjMap:this.dataObjMap,
                    dataType:this.dataType
				}

				if(this.dataType=="min"){
					this.filtersChche.min=obj;
					if(in_array('分钟',this.dynamicTags)){
					}else{
						this.dynamicTags.push('分钟');
					}
					this.changeTabClass('分钟');
				}else if(this.dataType=="hour"){
					this.filtersChche.hour=obj;
					if(in_array('小时',this.dynamicTags)){
					}else{
						this.dynamicTags.push('小时');
					}
					this.changeTabClass('小时');
				}else if(this.dataType=="day"){
					this.filtersChche.day=obj;
					if(in_array('天',this.dynamicTags)){
					}else{
						this.dynamicTags.push('天');
					}
					this.changeTabClass('天');
				} 
			},
            changeTabClass(val){
				var count=0;
				var domTabs=document.getElementsByClassName("dataTab");
				for(var i=0;i<domTabs.length;i++){
					var domone=domTabs[i];
					if(domone.innerText==val){
						domone.classList.add("tabSelect");
						count++;
					}else{
						domone.classList.remove("tabSelect");
					}
				}
				var timecount=0;
				var timer=setInterval(() => {
					timecount++;
					if(count!=0||timecount>10){
						clearInterval(timer);
					}else{
						var len=document.getElementsByClassName("dataTab").length;
						var domone=domTabs[len-1];
						domone.classList.add("tabSelect");
						count++;
					}
				}, 100);
			},
            drawLineChart:function(aData,seriesData) {
                this.chooseNames=this.filters.mn;
                //默认是员工模式，如果是客户的话，需要对name进行转换
                if(this.type==1){
                    this.changeMNToName(seriesData);
                }
                var tit = ['','',''];
                var legendTep = tit.concat(this.chooseNames);

                var lgdStyle={
                    data: legendTep,
                    itemWidth: 10,  // 设置宽度
                    itemHeight: 10 // 设置高度
                };
               
                var topH=parseInt(seriesData.length/8)*20+60;
                if(topH>220){
                    topH=220;
                }

                if(this.fatherUserId!=0){
                    lgdStyle={
                        type: 'scroll', //分页类型
                        data: legendTep,
                        top:30,
                        itemWidth: 10,  // 设置宽度
                        itemHeight: 10// 设置高度
                    };
                    topH=70;
                }
                this.chartLine = echarts.init(document.getElementById('chartLine'));
                this.chartLine.setOption({
                    title: {
                        text: this.factorName+'数据趋势图',
                        // text: '数据趋势图',
                        x:'center'
                    },
                    tooltip: {
                        trigger: 'axis',
                        position: function(point, params, dom, rect, size){
                            //其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
                            var x = point[0];//
                            var y = point[1];
                            var boxWidth = size.contentSize[0];
                            var boxHeight = size.contentSize[1];
                            var posX = 0;//x坐标位置
                            var posY = 0;//y坐标位置
                            
                            if(x<boxWidth){//左边放不开
                                posX = x+50;    
                            }else{//左边放的下
                                posX = x-boxWidth; 
                            }
                            
                            if(y<boxHeight){//上边放不开
                                if(boxHeight<400){
                                    posY=80;
                                }else{
                                    posY = -80; 
                                }
                            }else{//上边放得下
                                posY = y-boxHeight;
                            }
                            
                            return [posX,posY];
                        }
                    },
                    toolbox: {
                        show : true,
                        feature: {
                            dataZoom: {
                                yAxisIndex:"none"
                            },
                            magicType: {show: true, type: ['line', 'bar']},
                            saveAsImage: {
                                show:true,
                                excludeComponents :['toolbox'],
                                pixelRatio: 2
                            }
                         }
                    },
                    legend:lgdStyle,
                    grid: {
                        top: topH,
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
                        name:'时间',
                        data:aData
                    },
                    yAxis: {
                        type: 'value',
                        name:'数值',
                        scale:true
                    },
                    series:seriesData
                },true);

                var _this=this;
                if(this.linkage){
                    this.chartLine.off('click');
                    this.chartLine.on('click', function (param) {
                        var mn=param.data.name;
                        _this.chooseDeviceName=_this.deviceMap.get(mn)
                        var dataObj=_this.dataObjMap.get(mn);
                        var index=param.data.xAxis;//第几个数据
                        if(dataObj.noiseAlarm[index]!="-"){
                            _this.noiseVideo=eval("("+dataObj.noiseAlarm[index]+")");
                        }else{
                            _this.noiseVideo=[];
                        }
                        if(dataObj.recording[index]!="-"){
                            _this.recording=eval("("+dataObj.recording[index]+")");
                        }else{
                            _this.recording=[];
                        }
                        if(dataObj.stateInfo[index]!="-"){
                            _this.stateInfo=eval("("+dataObj.stateInfo[index]+")");
                        }else{
                            _this.stateInfo=[];
                        }

                        //处理异常报警
                        if(_this.stateInfo.length>0){
                            for (let index = 0; index < _this.stateInfo.length; index++) {
                                const data = _this.stateInfo[index];
                                data.remark=setDeviceEvent(data);
                            }
                        }
                        if(_this.recording.length>0){
                            _this.recording.forEach(element => {
                                element.src=window.configuration.resourceUrlJava+"recording/"+mn+"/"+element.fileFolderName+"/"+element.filename;
                            });
                        }

                        _this.chooseTime=dataObj.timeList[index];
                        _this.chooseValue=param.data.yAxis;
                        _this.deviceDataVisible=true;
                    });
                }
            },
            //查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
                    this.projects = res.data.data;
                    this.listLoading = false;
			        if(this.projects.length>0){
                        this.filters.projectId=[];
                        this.filters.projectId.push(this.projects[0].projectId);
						this.getDevices();
					}
				});
			},
            //获取趋势分析数据
            getDataList(){
                if(this.filters.mn.toString()==""){
                    this.$message({
						message: "设备MN不能为空",
						type: 'error'
					})
					return;
                }
                var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
                    endtime=formatDate(this.filters.time[1]);

                    var day=90;
					if(this.dataType=="min"){
						day=31;
					}
                    if(this.dataType=="day"){
						day=730;
					}
					//如果开始时间超过三个月
					var d1 = new Date(this.filters.time[0]);
					var d2 = new Date(this.filters.time[1]);
					var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
					if(days>day){
						this.$message({
							message: "选择时间范围超过"+day+"天",
							type: 'warn'
						})
						return;
					}
                }
                let para = {
                    mn: this.filters.mn.toString(),
                    dataType:this.dataType,
                    factorId: this.filters.facKeyword,
                    startDate: starttime,
                    endDate: endtime,
					linkage:this.linkage.toString()
                };
                this.listLoading = true;
                
				selectNoiseDataForTime(para).then((res) => {
                    this.listLoading = false;

                    //数据格式处理
                    var resData = res.data;
                    let aData=[];
                    let seriesData=[];
                    var icons=getIcons();
                    var i=0;
                    var iconsLen=icons.length;
                    this.dataObjMap=new Map();
                    this.filters.mn.forEach((item)=>{

                        var dataObj = resData[item];
                        var data= dataObj[this.filters.facKeyword];

                        let deviceOne={};
                        deviceOne.type='line';
                        deviceOne.symbol=icons[i%iconsLen];
                        deviceOne.name=item;
                        deviceOne.connectNulls=false;//null中断
                        deviceOne.data=data;

                        //判断有没有事件
                        if(this.linkage){
                            var pointdata=[];
                            for (let index = 0; index < data.length; index++) {
                                const element = data[index];
                                //1、先判断异常事件  stateInfo  红色
                                if( dataObj.stateInfo[index]!="-"){
                                    pointdata.push({
                                        name: item, value: '事件', xAxis: index, yAxis: element,itemStyle: { color:'#FF0033' }
                                    })
                                }else if( dataObj.noiseAlarm[index]!="-"){
                                    pointdata.push({
                                        name:item, value: '定位', xAxis: index, yAxis: element,itemStyle: { color:'#FF9900' }
                                    })
                                }else if( dataObj.recording[index]!="-"){
                                    pointdata.push({
                                        name: item, value: '录音', xAxis: index, yAxis: element,itemStyle: { color:'#FF9900' }
                                    })
                                }
                            }
                            if(pointdata.length>0){
                                deviceOne.markPoint={data:pointdata}
                            }
                        }

                        if(i==0){
                            aData=dataObj.timeList;
                        }

                        this.dataObjMap.set(item,dataObj);

                        deviceOne.smooth=true;//光滑连接
                        seriesData.push(deviceOne);
                        i++;
                    });
                    this.drawLineChart(aData,seriesData);     
                    //需要添加tab
                    this.addTab(aData,seriesData); 
				}).catch(() => {
					this.listLoading = false;
				});
            },
            //获取设备列表
			getDevices() {
                 if(this.filters.projectId.toString()==""){
                    return;
                }
                this.listLoading = true;
                let para = {
                    projectId: this.filters.projectId.toString()
                };
				getDevicesByProjectId(para).then((res) => {
                    this.listLoading = false;
                    
                    this.devices = res.data.data;
                    this.filters.mn=[];
                    // this.deviceName=[];
                    if( this.devices.length>0){
                        this.filters.mn.push(res.data.data[0].mnCode);

                    for (let index = 0; index <   this.devices.length; index++) {
                        const element =   this.devices[index];
                        this.deviceMap.set(element.mnCode,element.name);
                    }
                        // this.deviceName.push(res.data[0].name);     
                    }
                    this.getFactorsByMn();
				});
            },
            //历史数据导出信息
			dataTableToExcel(){
                 if(this.filters.mn.toString()==""){
                    this.$message({
						message: "设备MN不能为空",
						type: 'error'
					})
					return;
                }
				var starttime='';
                var endtime='';
                if(this.dataType=="min"){
                    this.dayLimit=31;
                }else  if(this.dataType=="hour"){
                    this.dayLimit=99;
                }else  if(this.dataType=="day"){
                    this.dayLimit=366;
                } 
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
					
					var day=this.dayLimit;
					//如果开始时间超过三个月
					var d1 = new Date(this.filters.time[0]);
					var d2 = new Date(this.filters.time[1]);
					var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
					if(days>day){
						this.$message({
							message: "选择时间范围超过"+day+"天",
							type: 'warn'
						})
						return;
					}

					
					//如果格式为年月日
					if(starttime.indexOf(':')==-1){
						starttime+=" 06:00:00";
						endtime+=" 05:59:59";
					}
					//处理结束时间加一天
					var d3 = new Date(endtime);
					d3.setDate(d3.getDate()+1);
					endtime=formatDate(d3);
                }
                for (let index = 0; index <   this.filters.mn.length; index++ ) {
                    let para = {
                        dataType:this.dataType,
                        mn: this.filters.mn[index],
                        startDate: starttime,
                        endDate: endtime
                    };
                    if(para.mn!=""){
                        this.exportToExcel(para);
                    }
                }
			},

            //历史数据导出信息 单台
			exportToExcel(para){
				this.listLoading = true;
				exportToExcel(para).then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"||res.data.result==false){
                        this.$message({
                            message: "导出数据失败",
                            type: 'error'
                        })
                    }else{
                        var paths=res.data.data.file;
						if(paths==""||paths.indexOf(".xls")==-1){
							this.$message({
								message: "选择时间范围内暂无数据",
								type: 'success'
							});
							return;
						}
						var url=window.configuration.noParamUrl+paths;
						window.open(url, "_blank");
                    }
				}).catch(function(err) {
					this.listLoading = false;
				});
			},
            //获取选中设备可监测的因子
            getFactorsByMn(){
                // this.getDeviceName();
                if(this.filters.mn.toString()==""){
                    return;
                }
                if(in_array('-2',this.filters.mn)){
                    this.filters.mn=[];
                    return;
                }
                if(in_array('-1',this.filters.mn)){
                    this.filters.mn=[];
                    this.devices.forEach(element => {
                        this.filters.mn.push(element.mnCode);
                    });
                }
                let para = {
                    mn: this.filters.mn.toString(),
                    dataType:this.dataType
                };
				getFactorsByMn(para).then((res) => {
                    
                    this.factors = res.data.data;

                    var nullFactor=[];
                    if(this.dataType=="hour"){
                        nullFactor=hourFactorExcept();
                    }else if(this.dataType=="min"){
                        nullFactor=minFactorExcept();
                    }
                    this.facList=[];
                    var arr=factorExcept();
                    for (let index = 0; index <   this.factors.length; index++ ) {
                        var element=this.factors[index];
                        if(in_array(element.keyword,arr)){
                            continue
                        }
                        if(in_array(element.keyword,nullFactor)){
                            continue;
                        }
                        this.facList.push(element);
                    }

                    // this.filters.facKeyword="";
                    this.factorName="";
                    var facFlag=true;
                     if(this.facList.length>0){
                        this.facList.forEach(element => {
                            if(element.keyword==this.filters.facKeyword){
                                facFlag=false;
                                return;
                            }
                        });
                        if(facFlag){
                            this.filters.facKeyword=this.facList[0].keyword;
                            this.factorName=this.facList[0].name; 
                        }  
                    }else{
                        this.filters.facKeyword="";
                        this.$message({
                            message: "选择设备没有共同的因子",
                            type: 'error'
                        })
                    }
                     if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
            getDataType(){
                var nullFactor=[];
                if(this.dataType=="hour"){
                    nullFactor=hourFactorExcept();
                }else if(this.dataType=="min"){
                    nullFactor=minFactorExcept();
                }
                this.facList=[];
                var arr=factorExcept();
                for (let index = 0; index <   this.factors.length; index++ ) {
                    var element=this.factors[index];
                    if(in_array(element.keyword,arr)){
                        continue
                    }
                    if(in_array(element.keyword,nullFactor)){
                        continue;
                    }
                    this.facList.push(element);
                }
            },
            //获取选中因子的名称，用于图表左侧显示
            getFactorName:function(){
                var obj=JSON.parse(sessionStorage.getItem(this.filters.facKeyword));
                this.factorName=obj.name;
            },
            //获取选中设备的名称，用于显示图例 暂时不用
            changeMNToName:function(seriesData){
                this.chooseNames=[];
                seriesData.forEach(item => {
                     this.devices.forEach(devOne => {
                        if(item.name==devOne.mnCode){
                            item.name=devOne.name;
                            this.chooseNames.push(devOne.name);
                            return;
                        }
                    });
                });
            },
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
                this.formHeight=hgt-titleHgt-toolbarHgt-120;
                document.getElementById("chartLine").style.height=this.formHeight+"px";
			},
			setTime(){
                var end = new Date();
				var start = new Date();
				this.dataType="min";
				start.setTime(start.setHours(start.getHours()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			}
        },
        mounted: function () {

            var user =JSON.parse(sessionStorage.getItem("user"));
            this.fatherUserId=user.fatherUserId;
            
            var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
            },10)
            this.setTime();
            this.type=sessionStorage.getItem("type");

            window.onresize = function(){
                if(_this.chartLine!=null){
                    _this.chartLine.resize();
                }
            }
        }
    }
</script>

<style scoped>
    .el-col-1{
        text-align: center;
    }
    .dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
    .tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>



// WEBPACK FOOTER //
// FactorAnalytical.vue?be5a103c